import { styled } from "@mui/material";
import { CSSProperties } from "react";

const Text = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "fontSize" &&
    prop !== "lineHeight" &&
    prop !== "fontFamily" &&
    prop !== "fontWeight" &&
    prop !== "fontStyle" &&
    prop !== "letterSpacing" &&
    prop !== "color" &&
    prop !== "textDecoration" &&
    prop !== "textAlign" &&
    prop !== "WebkitLineClamp",
})<{
  fontSize?: number;
  lineHeight?: number | string;
  fontFamily?: string;
  fontWeight?: number | string;
  fontStyle?: string;
  letterSpacing?: string;
  color?: string;
  textDecoration?: string;
  textAlign?: CSSProperties["textAlign"];
  WebkitLineClamp?: number;
}>(
  ({
    fontSize = 14,
    fontWeight = 500,
    fontFamily = "Poppins",
    letterSpacing = "0.0em",
    fontStyle = "normal",
    color = "#111111",
    textDecoration = "none",
    textAlign = "left",
    WebkitLineClamp = 3,
  }) => ({
    fontSize,
    fontWeight,
    fontFamily,
    letterSpacing,
    fontStyle,
    color,
    textDecoration,
    textAlign,
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp,
    overflow: "hidden",
    textOverflow: "ellipsis",
  })
);

export default Text;
